// extracted by mini-css-extract-plugin
export var button = "_g5-4";
export var hasDarkBackground = "_g5-7";
export var hasLightBackground = "_g5-6";
export var iconWrapper = "_g5-0";
export var large = "_g5-2";
export var medium = "_g5-1";
export var small = "_g5-5";
export var xsmall = "_g5-3";